import { useState, createContext, useMemo, useCallback } from "react";
import { User } from "../../../types/ClientSpace";

type PersonalData = { id: number | null, firstName: "", lastName: ""} & Omit<User, "password" | "name">;
type PersonalDataContextType = 
    PersonalData &
    {
        updatePersonalData: Function;
    };

export const PersonalDataContext =
    createContext<PersonalDataContextType>({
        id: null,
        firstName: "",
        lastName: "",
        email: "",
        phoneNumber: "",
        updatePersonalData: (signupForm: any) => null,
    });


export const PersonalDataContextProvider = ({ children }: any) => {
    const [personalData, setPersonalData] =
        useState<PersonalData>({
            id: null,
            firstName: "",
            lastName: "",
            email: "",
            phoneNumber: "",
        });

    const updatePersonalData = useCallback(
        (personalData: PersonalData) => {
            setPersonalData(personalData);
        },
        []
    );

    const PersonalDataWrapperContext = useMemo(
        () => ({
            ...personalData,
            updatePersonalData,
        }),
        [personalData, updatePersonalData]
    );

    return (
        <PersonalDataContext.Provider
            value={PersonalDataWrapperContext}
        >
            {children}
        </PersonalDataContext.Provider>
    );
};